export default __webpack_public_path__ + "static/media/picnic.84bb5005.jpeg";